import React from "react";
import "./index.scss";

const WarningSign = (props) => {
  const body = {
    message: "Warning",
    visible: true,
    messageColor: "#ffffe0",
    signColor: "#f4c430",
    ...props,
  };
  return (
    <div
      className={"warning-sign-body"}
      style={{ display: body.visible ? "flex" : "none", backgroundColor: body.signColor }}
    >
      <div className={"icon-sign"} style={{color: body.messageColor, border: `2px solid ${body.messageColor}`}}>!</div>{" "}
      <p className={"sign-message"} style={{color: body.messageColor}}>{body.message}</p>
    </div>
  );
};

export default WarningSign;
